<template>
  <div class="container-fluid tabactivites">
    <div class="row">
      <div class="col py-4" :class="{ out: active == 'genou' }" @click="changeActivite('hanche')">
        <h1>ACTIVITÉS</h1>
        <h2>HANCHE</h2>
      </div>
      <div class="col py-4" :class="{ out: active == 'hanche' }" @click="changeActivite('genou')">
        <h1>ACTIVITÉS</h1>
        <h2>GENOU</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabactivites",
  components: {},
  props: {
    active: { type: String, default: "hanche" }
  },
  data() {
    return { showhelp: false };
  },
  async mounted() {},
  watch: {},
  computed: {},
  methods: {
    changeActivite(activite) {
      this.$store.commit("set_currentactivite", activite);
      this.$emit("changeActive", activite);
    }
  }
};
</script>
<style scoped lang="scss">
.tabactivites .out {
  background: #ffffff;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(235, 235, 235, 1) 100%);

  h1,
  h2 {
    color: rgba(161, 173, 194, 1);
  }
}
</style>
